import EquityMarketNotifications from 'modules/trading/pages/EquityMarketNotifications';
import { EquityMarketProvider } from '../contexts/EquityMarketContext';

const EquityMarketNotificationsContainer = () => (
  <EquityMarketProvider>
    <EquityMarketNotifications />
  </EquityMarketProvider>
);

export default EquityMarketNotificationsContainer;
